import React, { useEffect, useState } from 'react';
import { Grid, Card, CardHeader, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { getWebSubscriberSummary } from '../../services/reports.service';
import CountWidget from './count-widget.component';
import {
  LS_ADMIN_USER_ROLE,
  VALID_ADMIN_ROLES,
} from '../../config/const.config';
import { getLocalValue } from '../../utils/local-cache.util';
import { formatDate } from '../../utils/datetime.util';

const WebSubscriberSummary = ({ selectedChannel, startDate, endDate }) => {
  const userRole = getLocalValue(LS_ADMIN_USER_ROLE);
  const [summary, setSummary] = useState({ monthly: [], yearly: [] });
  const [filters, setFilters] = useState({
    channel: null,
    platform: null,
    reloadCounter: 0,
    loading: true,
  });

  const fetchData = async () => {
    setFilters({
      ...filters,
      loading: true,
    });
    const params = {
      fromDate: formatDate(startDate, 'YYYY-MM-DD'),
      toDate: formatDate(endDate, 'YYYY-MM-DD'),
      channelId: selectedChannel || 0,
    };
    getWebSubscriberSummary(params)
      .then((res) => {
        const data = res.data || {};
        setSummary({
          monthlyPaid: data.monthly.paid || 0,
          monthlyTrial: data.monthly.trial || 0,
          yearlyPaid: data.yearly.paid || 0,
          yearlyTrial: data.yearly.trial || 0,
        });

        setFilters({
          ...filters,
          loading: false,
        });
      })
      .catch(() => {
        setFilters({
          ...filters,
          loading: false,
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, [selectedChannel, startDate, endDate, filters.reloadCounter]);

  return (
    <Box mt={5}>
      <Card>
        <CardHeader title="Web Subscribers Only" />
        <Grid container spacing={3} mb={3}>
          <Grid
            item
            xs={12}
            sm={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
            md={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
          >
            <CountWidget
              title="Monthly Paid"
              total={summary.monthlyPaid}
              icon="mdi:cash"
              color="success"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
            md={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
          >
            <CountWidget
              title="Monthly Trial"
              total={summary.monthlyTrial}
              icon="mdi:account-clock"
              color="warning"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
            md={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
          >
            <CountWidget
              title="Yearly Paid"
              total={summary.yearlyPaid}
              icon="mdi:cash"
              color="success"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
            md={userRole === VALID_ADMIN_ROLES.CHANNEL_OWNER ? 4 : 3}
          >
            <CountWidget
              title="Yearly Trial"
              total={summary.yearlyTrial}
              icon="mdi:account-clock"
              color="warning"
            />
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

WebSubscriberSummary.propTypes = {
  selectedChannel: PropTypes.number.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default WebSubscriberSummary;
